import React from 'react';
import sanitizeHtml from 'sanitize-html';
import { Icon } from '@workboard/action-item';
import { getAiTypeAttributes, getStateComponentIcon } from '../../board/utils';
import { WbEventHandlerMixins, WbMarkdownHtml, wbStripHtmlEvents } from '../../utils/common';
import ConfidenceFlag from '../common/confidenceFlag.component';

import PostTopicEditText from './postTopicEditText';

import { WoboFileUploadService } from '../../../src/services/fileupload.service'

class WobTypeTopic extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      items: this.props.topicDet || [],
      _items: this.props.topicDet || [],
      type: 'topic',
      editTopicDescEdit: this.props.editTopicDescEdit || false,
      wb_type: false
    };
    this.rowItem = this.rowItem.bind(this);
    this.editTopic = this.editTopic.bind(this);
    this.goalDetailPage = this.goalDetailPage.bind(this);
    this.objectArear = this.objectArear.bind(this);
    this.aiArear = this.aiArear.bind(this);
    this.aiTopicArea = this.aiTopicArea.bind(this);
    this.wsArear = this.wsArear.bind(this);
    this.krArear = this.krArear.bind(this);
    this.handleFileDownload = this.handleFileDownload.bind(this);
    this.handleLinkDownload = this.handleLinkDownload.bind(this);
    this.attcArear = this.attcArear.bind(this);
    this.attcLinkArear = this.attcLinkArear.bind(this);
    this.editTopicTextDesc = this.editTopicTextDesc.bind(this);
    this.disableTopicText = this.disableTopicText.bind(this);
    this.selectAllTopicText = this.selectAllTopicText.bind(this);
    this.topicArear = this.topicArear.bind(this);
    this.krDetailPage = this.krDetailPage.bind(this);
    this.renderFileName = this.renderFileName.bind(this);
  }

  componentDidUpdate () {
    // TODO: needs evaluation of the logic here, are these conditionals correctly preventing state change/render loops?
    // setState usage in componentDidUpdate is questionable but allowable if conditional protections are met
    const _items = this.props.topicDet || [];
    let editTopic = false;
    if (this.state.editTopicDescEdit && this.props.editTopicDescEdit == false) {
      editTopic = true;
      // eslint-disable-next-line
      this.setState({
        editTopicDescEdit: this.props.editTopicDescEdit,
        items: { ...this.state.items, ..._items }
      });
    } else if (
      !editTopic
      && ((typeof _items.description !== 'undefined'
        && this.state.items.description !== 'undefined'
        && _items.description != this.state.items.description)
        || (typeof _items.wobo_type !== 'undefined'
          && _items.wobo_type != this.state.items.wobo_type))
          || (typeof _items.recurringTopic !== 'undefined'
          && _items.recurringTopic != this.state.items.recurringTopic)
          || (typeof _items.meeting_context !== 'undefined'
          && _items.meeting_context != this.state.items.meeting_context)
    ) {
      // eslint-disable-next-line
      this.setState({
        items: { ...this.state.items, ..._items }
      });
    }
  }

  rowItem (item) {
    if (item.wobo_type == 'workstream') {
      return this.wsArear(item);
    }
    if (item.wobo_type == 'objective') {
      return this.objectArear(item);
    }
    if (item.wobo_type == 'ai') {
      return this.aiArear(item);
    }
    if (item.wobo_type == 'key_result') {
      return this.krArear(item);
    }
    if (item.wobo_type == 'attachment') {
      return this.attcArear(item);
    }
    if (item.wobo_type == 'attachment_link') {
      return this.attcLinkArear(item);
    }
    if (item.wobo_type == 'topic' && item.tag == 1 && item.ai_id && typeof item.wobo_data == 'object') {
      return this.aiTopicArea(item);
    }
    if (item.wobo_type == 'topic') {
      return this.topicArear(item);
    }
    console.warn(`Unknown topic type "${item.wobo_type}"`);

    return this.topicArear(item);
  }

  editTopic (id) {
    this.props.editTopicTextDesc(id);
  }

  goalDetailPage (goalId, metricId, viewAccess = 'true', parentId = 0) {
    if (viewAccess == 'false') {
      return;
    }
    const params = {};
    if (typeof goalId !== 'undefined' && goalId != '') {
      params.id = goalId;
    }
    if (typeof metricId !== 'undefined' && metricId != '') {
      params.id = goalId;
      params.metricId = metricId;
    }
    // console.log(parentId);
    if (parentId) {
      return viewCascadeMetric(params.metricId);
    }
    return viewGoalDetailsPage(undefined, params);
  }

  krDetailPage (goalId, metricId, viewAccess = 'true', meetingType = '3') {
    if (viewAccess == 'false') {
      return;
    }

    let srcVal = 'oneOnOneAgenda';
    if (meetingType == '2' || meetingType == '3') {
      srcVal = 'meetingAgenda';
    }
    const url = `${wbConfig.baseUrl}/goal/krDetails?id=${metricId}&ref=${srcVal}`;
    window.open(url);
  }

  objectArear (item) {
    const { wobo_data } = item;
    const { interval } = this.props.meeting;
    const { recurringTopic } = item;
    const displayName = `by ${item.firstname} ${item.lastname
      .charAt(0)
      .toUpperCase()}`;
    const percentage = wobo_data.goal_percentage.indexOf('-1') >= 0
      || wobo_data.goal_percentage < 0
      ? '--'
      : `${wobo_data.goal_percentage}%`;
    const goalOwnerName = wobo_data.ownerName ? wobo_data.ownerName : '';
    const goalTeamName = wobo_data.teamName ? wobo_data.teamName : '';
    return (
      <div className="object-div-section" style={{ paddingRight: 10 }}>
        <div
          className="textAlignLeft goalTopic titleLinkCl"
          data-topic={item.id}
        >
          <span
            className={`wb-table-col-edit-title-desc wrap meetingCursorPointer objectArea titleText_${item.id}`}
            data-view-acces={wobo_data.view_access}
            onClick={() =>
              this.goalDetailPage(
                item.wobo_data.id,
                undefined,
                wobo_data.view_access
              )}
          >
            {wobo_data.goal}
          </span>
        </div>
        <div
          className="dispIB"
          style={{ width: '10%', textAlign: 'right', verticalAlign: 'top' }}
        >
          <span
            className="numberFont dispIB"
            style={{ color: wobo_data.goal_percentage_color }}
          >
            {percentage}
          </span>
        </div>
        <div className="wb-table-col-addedby width100 paddTopZero">
          {goalTeamName != '' && (
            <span
              className="topicTeamName truncateText wsTeamName"
              title={goalTeamName}
            >
              {goalTeamName}
            </span>
          )}
          {goalTeamName != '' ? (
            <span
              className="topicTeamName truncateText wsTeamName"
              title={wobo_data.ownerName}
            >{` : ${goalOwnerName}`}
            </span>
          ) : (
            <span
              className="topicTeamName truncateText wsTeamName"
              title={wobo_data.ownerName}
            >
              {goalOwnerName}
            </span>
          )}
          <span className="topicUserName truncateText floatRight addedMarginGoal">
            {item.hoverName == item.id ? displayName : ''}
          </span>
        </div>
      </div>
    );
  }

  aiArear (item) {
    const { wobo_data } = item;
    const { interval } = this.props.meeting;
    const { recurringTopic } = item;
    const displayName = `by ${item.firstname} ${item.lastname
      .charAt(0)
      .toUpperCase()}`;
    const wobo_due_date = wobo_data.due_date
      ? moment.utc(wobo_data.due_date * 1000).format('MMM DD')
      : '';
    const wsName = wobo_data.wsName ? wobo_data.wsName : '';
    const wsownerName = wobo_data.ownerName ? wobo_data.ownerName : '';
    const { attributes } = getAiTypeAttributes(wobo_data?.type ?? 0);
    const ragIconName = getStateComponentIcon(
      attributes?.rag?.values ?? [],
      wobo_data.rag
    );
    const priorityIconName = getStateComponentIcon(
      attributes?.priority?.values ?? [],
      wobo_data.priority
    );
    return (
      <div>
        <div className="ai-div-section" style={{ marginTop: '3px' }}>
          <div
            className="textAlignLeft actionItTopic titleLinkCl"
            data-topic={item.id}
          >
            <div
              className={`wb-table-col-edit-title-desc wrap meetingCursorPointer aiArea titleText_${item.id}`}
              data-view-acces={wobo_data.view_access}
              onClick={() =>
                WbEventHandlerMixins.aiDetailPage(
                  item.wobo_data.id,
                  this,
                  wobo_data.view_access
                )}
              style={{ minWidth: '90%', maxWidth: '95%' }}
            >
              {wobo_data.description}
            </div>
          </div>
          <div className="dispIB iconsAITopic">
            <div className="dispFlex floatRight width100">
              <span className="meet-wobo-ai-duedate">{wobo_due_date}</span>
              <span
                className="wsRag meet-wobo-ai-rag"
                style={{ width: '15px' }}
              >
                <Icon name={ragIconName} width="15" height="15" />
              </span>
              <span
                className="wbStatus meet-wobo-ai-state"
              >
                <Icon name={priorityIconName} width="15" height="15" />
              </span>
            </div>
          </div>
        </div>
        <div className="ai-div-section width100  truncateText">
          {wsName != '' && (
            <span
              className="topicTeamName truncateText wsTeamName floatLeft"
              title={wsName}
            >
              {wsName}
            </span>
          )}
          {wsName != '' ? (
            <span
              className="topicTeamName truncateText wsTeamName floatLeft"
              title={wsownerName}
            >{` : ${wsownerName}`}
            </span>
          ) : (
            <span
              className="topicTeamName truncateText wsTeamName floatLeft"
              title={wsownerName}
            >
              {wsownerName}
            </span>
          )}
          <span className="topicUserName truncateText floatRight dispIB addedMargin">
            {item.hoverName == item.id ? displayName : ''}
          </span>
        </div>
      </div>
    );
  }

  aiTopicArea (item) {
    const { wobo_data } = item;
    const { interval } = this.props.meeting;
    const { recurringTopic } = item;
    const displayName = `by ${item.firstname} ${item.lastname
      .charAt(0)
      .toUpperCase()}`;
    const wobo_due_date = wobo_data.due_date
      ? moment.utc(wobo_data.due_date * 1000).format('MMM DD')
      : '';
    const wsName = typeof wobo_data.wsName !== 'undefined' ? wobo_data.wsName : '';
    const wsownerName = typeof wobo_data.ownerName !== 'undefined' ? wobo_data.ownerName : '';
    const { attributes } = getAiTypeAttributes(wobo_data?.type ?? 0);
    const ragIconName = getStateComponentIcon(
      attributes?.rag?.values ?? [],
      wobo_data.rag
    );
    const priorityIconName = getStateComponentIcon(
      attributes?.priority?.values ?? [],
      wobo_data.priority
    );
    return (
      <div>
        <div className="ai-div-section" style={{ marginTop: '3px' }}>
          <div
            className="textAlignLeft actionItTopic titleLinkCl"
            data-topic={item.id}
          >
            <div
              className={`wb-table-col-edit-title-desc wrap meetingCursorPointer aiTopicArea titleText_${item.id}`}
              data-view-acces={wobo_data.view_access}
              onClick={() =>
                WbEventHandlerMixins.aiDetailPage(
                  item.wobo_data.id,
                  this,
                  wobo_data.view_access
                )}
            >
              {wobo_data.description}
            </div>
          </div>
          <div className="dispIB iconsAITopic">
            <div className="dispFlex floatRight width100">
              <span className="meet-wobo-ai-duedate">{wobo_due_date}</span>
              <span
                className="wsRag meet-wobo-ai-rag"
              >
                <Icon name={ragIconName} width="15" height="15" />
              </span>
              <span
                className="wbStatus meet-wobo-ai-state"
              >
                <Icon name={priorityIconName} width="15" height="15" />
              </span>
            </div>
          </div>
        </div>
        <div className="ai-div-section width100  truncateText">
          {wsName != '' && (
            <span
              className="topicTeamName truncateText wsTeamName floatLeft"
              title={wsName}
            >
              {wsName}
            </span>
          )}
          {wsName != '' ? (
            <span
              className="topicTeamName truncateText wsTeamName floatLeft"
              title={wsownerName}
            >{` : ${wsownerName}`}
            </span>
          ) : (
            <span
              className="topicTeamName truncateText wsTeamName floatLeft"
              title={wsownerName}
            >
              {wsownerName}
            </span>
          )}
          <span className="topicUserName truncateText floatRight dispIB addedMargin">
            {item.hoverName == item.id ? displayName : ''}
          </span>
        </div>
      </div>
    );
  }

  wsArear (item) {
    const { wobo_data } = item;
    const { interval } = this.props.meeting;
    const { recurringTopic } = item;
    const displayName = `by ${item.firstname} ${item.lastname
      .charAt(0)
      .toUpperCase()}`;
    let healthImg = 'ws-health-good';
    let healthText = '';
    if (wobo_data.health == '1') {
      healthImg = 'ws-health-good';
      healthText = 'Good';
    } else if (wobo_data.health == '2') {
      healthImg = 'ws-health-ok';
      healthText = 'Ok';
    } else if (wobo_data.health == '3') {
      healthImg = 'ws-health-risk';
      healthText = 'Risk';
    }
    const progress = wobo_data.progress ? wobo_data.progress : 0;
    const wsownerName = wobo_data.wsLeadName ? wobo_data.wsLeadName : '';
    const wsHref = wobo_data.view_access == 'true'
      ? `/wb/activity/workstreams?id=${item.wobo_data.id}`
      : '';
    return (
      <div className="ws-div-section width100">
        <div className="textAlignLeft wsTopic titleLinkCl" data-topic={item.id}>
          {wobo_data.view_access == 'true' ? (
            <a
              className="ai-v1-popup ws-text-class wb-table-col-edit-title-desc wrap"
              href={wsHref}
              target="_blank"
              rel="noreferrer"
            >
              <span
                className={`wb-table-col-edit-title-desc wrap dispIB width80 floatLeft titleText_${item.id}`}
                style={{ fontSize: '13px' }}
              >
                {wobo_data.name}
              </span>
            </a>
          ) : (
            <span
              className={`wb-table-col-edit-title-desc wrap dispIB ws-text-class floatLeft titleText_${item.id}`}
            >
              {WbEventHandlerMixins.unSafeHtml(wobo_data.name)}
            </span>
          )}
          <span className="dispIB healthText">
            {healthText}
            <span className={healthImg} />
          </span>
          <span
            className="dispIB ws-progress-align numberFont"
            style={{ color: wobo_data.progress_color }}
          >
            {progress}%
          </span>
        </div>
        <div className="width100 paddTopZero">
          <span
            className="topicTeamName truncateText wsTeamName"
            title={wsownerName}
          >
            {wsownerName}
          </span>
          <span className="topicUserName truncateText floatRight dispIB addedMargin">
            {item.hoverName == item.id ? displayName : ''}
          </span>
        </div>
      </div>
    );
  }

  krArear (item) {
    const { wobo_data } = item;
    const { interval } = this.props.meeting;
    const { recurringTopic } = item;
    const displayName = `by ${item.firstname} ${item.lastname
      .charAt(0)
      .toUpperCase()}`;
    const targetData = wobo_data.total_target_text
      ? ` of ${wobo_data.total_target_text}`
      : '';
    const divStyle = {
      color: 'black'
    };
    const { displayKrConfidence } = this.props;

    return (
      <div className="kr-div-section">
        <div className="textAlignLeft krTopic titleLinkCl" data-topic={item.id}>
          <div
            className={`wb-table-col-edit-title-desc wrap first-span meetingCursorPointer titleText_${item.id}`}
            data-view-acces={item.wobo_data.view_access}
            onClick={() =>
              this.krDetailPage(
                item.wobo_data.goal_id,
                item.wobo_data.metric_id,
                item.wobo_data.view_access,
                item.wobo_data.parent_id,
                item.meetingType
              )}
          >
            {wobo_data.name}
          </div>
          <div className="second-span numberFont">
            <div style={{ color: wobo_data.progress_color }}>
              {wobo_data.achieve_target_text}
              <span style={divStyle} className="krTargetDate">
                {targetData}{' '}
              </span>
              <span>
                {displayKrConfidence
                  ? (wobo_data.confidence && wobo_data.confidence.confidence > 0
                    ? <ConfidenceFlag
                        type={wobo_data.confidence.confidence}
                        cDate={wobo_data.confidence.created_at_formatted}
                        uName={wobo_data.confidence.added_by_name}
                        comment={wobo_data.confidence.comment}
                        id={wobo_data.metric_id}
                        classProp="krRow"
                        style={{ marginTop: '-3px', verticalAlign: 'middle', textAlign: 'left' }}
                    /> : ''
                  ) : ''}
              </span>
            </div>
          </div>
        </div>
        <div className="dispIB" />
        <div className="wb-table-col-addedby paddTopZero width100">
          <div className="">
            <div className="topicUserName truncateText floatLeft addedMargin" />
            <div className="topicUserName truncateText floatLeft " />
            <div className="topicUserName truncateText floatRight addedMargin">
              {item.hoverName == item.id ? displayName : ''}
            </div>
            {item.total_target_text ? (
              <div className="krPercent">
                of
                {wobo_data.total_target_text}
              </div>
            ) : (
              ''
            )}
          </div>
        </div>
      </div>
    );
  }

  handleFileDownload (e, item) {
    e.preventDefault();
    const { isNoAttachmentDownload } = this.props;
    if (!isNoAttachmentDownload) return;
    if (item.fusType == 1 && item.fusStatus == 1) {
      const link = document.createElement('a');
      const url = `${wbConfig.baseUrl}`+ '/vnext/fus/api/v1/download/' + item.fileSignature
      console.log('download  attch url', url);
      WoboFileUploadService.download(url).then(async (res)=>{
          const blob = await res.blob();
          const blobUrl = URL.createObjectURL(new Blob([blob]));
          link.href = blobUrl;
          link.target = "_blank";
          link.setAttribute(
              "download",
              item.file_name
          );
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
      })
    } else if(item.fusType != 1) {
      return window.open(item.file_path, '_blank');
    }
  }

  handleLinkDownload (e, item) {
    e.preventDefault();
    const { isNoAttachmentDownload } = this.props;
    if (!isNoAttachmentDownload) return;
    return window.open(item.path, '_blank');
  }

  renderFileName(item, wobo_data,cursorPointer) {
    let fileName = sanitizeHtml(item.description, {
      allowedTags: [],
      disallowedTagsMode: 'discard'
    })
    let fusType = parseInt(wobo_data.fusType);
    let fusStatus = parseInt(wobo_data.fusStatus);
    if (!fusType) {
        return <span className={`wb-table-col-edit-title-desc wrap ${cursorPointer} titleText_${item.id}`} onClick={e => this.handleFileDownload(e, wobo_data)}>{fileName}</span>
    } else if (fusType) {
        if (fusStatus == 1) {
          return <span  className={`wb-table-col-edit-title-desc wrap ${cursorPointer} titleText_${item.id}`} onClick={e => this.handleFileDownload(e, wobo_data)}>{fileName}</span>
        } else if (fusStatus == 2) {
          return <span className={`wb-table-col-edit-title-desc wrap titleText_${item.id}`} >{fileName} (processing)</span>
        }  else if (fusStatus == 5) {
          return <span className={`wb-table-col-edit-title-desc wrap titleText_${item.id}`} >{fileName} (infected file, deleted)</span>
        } else {
          return <span className={`wb-table-col-edit-title-desc wrap titleText_${item.id}`} >{fileName}</span>
        }
    }
  }

  attcArear (item) {
    const { wobo_data } = item;
    const { interval } = this.props.meeting;
    const { recurringTopic } = item;
    const displayName = `Added by ${item.firstname} ${item.lastname
      .charAt(0)
      .toUpperCase()}`;
    const { isNoAttachmentDownload } = this.props;
    let cursorPointer = '';
    if (isNoAttachmentDownload) {
      cursorPointer = 'cursorPointer';
    }
    return (
      <div className="attc-div-section">
        <div
          className="textAlignLeft titleLinkCl"
          data-topic={item.id}
          style={{ marginTop: '3px' }}
        >
          {
            this.renderFileName(item,wobo_data,cursorPointer)
          }
        </div>
        <div className="wb-table-col-addedby floatRight addedMargin">
          <div className="width100">
            <div className="floatRight">
              <span className="topicUserName attachementDesc truncateText">
                {item.hoverName == item.id ? displayName : ''}
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  attcLinkArear (item) {
    const { wobo_data } = item;
    const { interval } = this.props.meeting;
    const { recurringTopic } = item;
    const displayName = `by ${item.firstname} ${item.lastname
      .charAt(0)
      .toUpperCase()}`;
    const { isNoAttachmentDownload } = this.props;
    const cursorPointer = isNoAttachmentDownload ? 'cursorPointer' : '';
    return (
      <div className="attc-div-section">
        <div
          className="textAlignLeft titleLinkCl"
          data-topic={item.id}
          style={{ marginTop: '3px' }}
        >
          <span
            className={`wb-table-col-edit-title-desc wrap  titleText_${item.id} ${cursorPointer}`}
            onClick={e => this.handleLinkDownload(e, wobo_data)}
          >
            {item.description}
          </span>
        </div>
        <div className="wb-table-col-addedby floatRight addedMargin">
          <div className="width100">
            <div className="floatRight">
              <span className="topicUserName attachementDesc truncateText">
                {item.hoverName == item.id ? displayName : ''}
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  editTopicTextDesc (e, id) {
    const { meetingObj } = this.props;
    // e.preventDefault();
    // e.stopPropagation();
    if (this.state.editTopicDescEdit != id && $(e.target).closest('a').length < 1) {
      this.setState({
        editTopicDescEdit: id
      }, () => {
        const eleId = `meeting_topic_${meetingObj.id}_${this.state.items.id}`;
        // autoResizeTextArea({ eleId: `#${eleId}` });
        $(`#${eleId}`).closest('.meetingTopicTakeDetails .topicHead, .meetingTopicTakeDetails .takeawayHead').hover(function () {
          $(this).css('background-color', '#ffffff');
        })
      });
    }
    this.props.disableHoverStick(id);
  }

  disableTopicText (id) {
    const { meetingObj } = this.props;
    if (this.state.editTopicDescEdit == id) {
      this.setState({
        editTopicDescEdit: false
      }, () => {
        const eleId = `meeting_topic_${meetingObj.id}_${this.state.items.id}`;
        $(`#${eleId}`).closest('.meetingTopicTakeDetails .topicHead, .meetingTopicTakeDetails .takeawayHead').hover(function () {
          $(this).css('background-color', 'inherit');
        })
      });
    }
    this.props.disableHoverStick(false);
  }

  selectAllTopicText (e, id) {
    const el = document.getElementsByClassName(`titleText_${id}`)[0];
    const range = document.createRange();
    range.selectNodeContents(el);

    const sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);
  }

  topicArear (item) {
    const { meetingObj, enableDiv, isTopicEmpty } = this.props;
    const cursorP = enableDiv ? 'text' : 'default';
    let topicDesc = '';
    let assignedTo = '';
    const styleObj = {
      cursor: cursorP,
      fontSize: '13px',
      color: '#000000',
      width: '94%'
    };

    if (item.ai_id != '' && item.ai_id != null && !isTopicEmpty) {
      const aiOwnerName = typeof item.aiOwnerName !== 'undefined' ? item.aiOwnerName : '';
      styleObj.width = '76%';
      styleObj.display = 'inline-block';
      assignedTo = (
        <span
          className="meeting-ai-link truncateText clickable dispIB"
          title={aiOwnerName}
          data-url={`${wbConfig.baseUrl}/activity/ActionItemDetails?id=${item.ai_id}&meetingId=${item.meeting_id}`}
          style={{ width: '22%', verticalAlign: 'top' }}
        >
          Assigned to {aiOwnerName}
        </span>
      );
    }
    if (isTopicEmpty) {
      styleObj.content = 'attr(placeholder)';
      styleObj.color = '#8c9ea2';
      styleObj.fontSize = '13px';
      styleObj.minHeight = '30px';
    }

    const { interval, provider_series_id, series_id } = this.props.meeting;
    const { recurringTopic } = item;
    const topicDescriptionText = isTopicEmpty ? '' : wbStripHtmlEvents(item.description);

    if (enableDiv) {
      topicDesc = (
        <div>
          <div
            className={`topicDescText dispIB titleText_${item.id}`}
            onClick={e => this.editTopicTextDesc(e, item.id)}
            style={styleObj}
            dangerouslySetInnerHTML={WbMarkdownHtml(topicDescriptionText, true)}
          />
          {assignedTo}
        </div>
      );
    } else {
      topicDesc = (
        <div>
          <div
            className={`topicDescText selectTopicSpan dispIB titleText_${item.id}`}
            onClick={e => this.selectAllTopicText(e, item.id)}
            style={styleObj}
            dangerouslySetInnerHTML={WbMarkdownHtml(topicDescriptionText, true)}
          />
          {assignedTo}
        </div>
      );
    }

    const textareaId = `meeting_topic_${meetingObj.id}_${item.id}`;
    if (this.state.editTopicDescEdit == item.id && $(`#${textareaId}`).length) {
      item = { ...item, description: $(`#${textareaId}`).html() };
    }
    return this.state.editTopicDescEdit == item.id && enableDiv ? (
      <PostTopicEditText
        meetingObj={meetingObj}
        topic={item}
        userPermission={this.props.userPermission}
        updateTopicTake={this.props.updateTopicTake}
        editTopicDescEdit={this.state.editTopicDescEdit}
        disableTopicText={this.disableTopicText}
        mtS3Data={this.props.mtS3Data}
        actions={this.props.actions}
      />
    ) : (
      <div className={`topic_${item.id}`} style={{ paddingLeft: '8.5%' }}>
        <div className="titleLinkCl" data-topic={item.id}>
          {topicDesc}
        </div>
        {!isTopicEmpty && (
          <div className="wb-table-col-sub-title">
            <span
              className="floatLeft"
              style={{
                padding: '0 10px 0 0',
                fontSize: '10px',
                color: '#8C9EA2',
                letterSpacing: '-0.16px',
                lineHeight: '20px',
                fontStyle: 'normal'
              }}
            >
              {item.hoverName == item.id
                ? `${item.firstname} ${item.lastname}`
                : ''}
            </span>
            <span
              className="floatLeft"
              style={{
                fontSize: '10px',
                color: '#8C9EA2',
                letterSpacing: '-0.16px',
                lineHeight: '20px'
              }}
            >
              {item.create_period}{' '}
            </span>
          </div>
        )}
      </div>
    );
  }

  render () {
    const { items } = this.state;

    return <div className="topic-section-div">{this.rowItem(items)}</div>;
  }
}
export default WobTypeTopic;
